import { render, staticRenderFns } from "./EstDes6.vue?vue&type=template&id=8cb9831a&scoped=true&"
import script from "./EstDes6.vue?vue&type=script&lang=js&"
export * from "./EstDes6.vue?vue&type=script&lang=js&"
import style0 from "./EstDes6.vue?vue&type=style&index=0&id=8cb9831a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb9831a",
  null
  
)

export default component.exports